export default {
    TOKEN: 'whajjOOks%%--s',
    STORAGE_TOKEN: 'kay&sqq_storage',
  
  
    NETWORK_CHAINID: '0x38',
    ACCOUNT_BALANCE: 'ACCOUNT_BALANCE',
  
    ADDRESS: 'ADDRESS',
    LOADINGDATA: 'LOADINGDATA',
    LOADINGDATAREWARD: 'LOADINGDATAREWARD',
    WALLETINUSE: 'WALLETINUSE',
    CONNDETAILS: 'CONN_DETAILS',
    
    NATIVE_BALANCE: 'NATIVE_BALANCE',
    XEND_BALANCE: 'XENDBALANCE',
    XEND_USD_PRICE: 'XENDBALANCE',
    TOTAL_STAKED_CONTRACT: 'TOTALSTAKEDCONTRACT',
    TOTAL_STAKED_CONTRACT_USD: 'TOTALSTAKEDCONTRACTUSD',
    USER_CATEGORIES: 'USERCATEGORIES',
    USER_CATEGORIES_WITHDRAW: 'USERCATEGORIESWITHDRAW',
  
    PRISTINE: 'ALL_PRISTINE',
    
    //providerSet
    WEB3SETPROVIDER: 'WEB3_SET_PROVIDER',

    NETWORK_CONNECT:'NETWORK_CONNECT',
    CONWALLETADD:'WALLETCONN',

    
    //web3HasDisconnected
    WEB3_WALLETCONNECT_HAS_DISCONNECTED: 'WEB3_WALLETCONNECT_DISCONNECTED',
  
    //NewNetworkChange
    NETWORK_PROVIDER_HAS_CHANGED: 'SELECTED_NETWORK_PROVIDER',
    CATEGORIES: 'CATEGORIES',
    USER_INFO: 'USERINFO',
    USER_REWARDS_SUMMED: 'USER_REWARDS_SUMMED',
    SIGNATURE: "SIGNATURE",
    APYS: "ALL_APYS",
    LOADING_WALLET: "LOADING_WALLET"
   
  };
  